import { render, staticRenderFns } from "./NewPromotionBaseSettingsDermo.vue?vue&type=template&id=1ff1affa&"
import script from "./NewPromotionBaseSettingsDermo.vue?vue&type=script&lang=js&"
export * from "./NewPromotionBaseSettingsDermo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports